import Vue from 'vue'
import PSlider from './components/PSlider.vue'

// Register PSlider globally so it can be used in templates
Vue.component('p-slider', PSlider)

// Initialize Vue instances for testimonial sliders if they exist on the page
// This ensures Vue can process the p-slider components in Twig templates
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialSliders)
} else {
    initTestimonialSliders()
}

function initTestimonialSliders() {
    const testimonialSliders = document.querySelectorAll('.testimonialSlider')

    testimonialSliders.forEach((sliderEl) => {
        // Check if Vue is already mounted to this element
        if (!sliderEl.__vue__) {
            // Mount Vue to the slider content container to enable Vue components
            const sliderContent = sliderEl.querySelector('.slider__content')

            if (sliderContent && !sliderContent.__vue__) {
                new Vue({
                    el: sliderContent,
                })
            }
        }
    })
}

